<template>
  <div class="rela">
    <Button
      type="primary"
      long
      :disabled="second>0||disabled"
      @click="handleClick"
    >{{second>0?$t('btn.b68').replace('{%}',second):$t('btn.b67')}}</Button>
  </div>
</template>
<script>
import Rsa from "@/libs/Rsa";
export default {
  props: ["type", "to","disabled","phoneAreaCode"],
  data() {
    return {
      second: 0,
      timer: null
    };
  },
  methods: {
    handleClick() {
      if (!this.type) return;
      this.timerStart()
      this[this.type]()
      .then(res => {
        if(res.err) this.timerClear()
        else this.$emit('sent');
        res.throw();
        
      })
      .catch(err=>{
        this.timerClear()
      });
    },
    timerStart() {
      this.second = 60
      this.timer = setInterval(() => {
        if (--this.second <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    timerClear() {
      this.second = 0;
      if (this.timer) clearInterval(this.timer);
    },

    // 重置密码
    SendResetPwdCode() {
      return this.$axios.post("/Member/RZJProfile/SendResetPwdCode", {
        passWord: Rsa(this.to.password),
        affirmPassWord: Rsa(this.to.copypassword),
        verificationType: this.to.verificationType
      })
    },
    // 绑定邮箱-手机验证码
    SendBindEmailPhoneCode() {
      return this.$axios.post("/Member/RZJProfile/SendBindEmailPhoneCode")
    },
    // 绑定邮箱-邮箱验证码
    SendBindEmailCode() {
      return this.$axios.post("/Member/RZJProfile/SendBindEmailCode", {
        email:this.to
      })
    },
    // 修改绑定邮箱-发送原邮箱验证码
    SendUpdateOldEmailCode(){
      return this.$axios.post("/Member/RZJProfile/SendUpdateOldEmailCode")
    },
    // 修改绑定邮箱-发送新邮箱验证码
    SendUpdateNewEmailCode() {
      return this.$axios.post("/Member/RZJProfile/SendUpdateNewEmailCode", {
        email:this.to
      })
    },
    // 绑定手机-邮箱验证码
    SendBindPhoneEmailCode(){
      return this.$axios.post("/Member/RZJProfile/SendBindPhoneEmailCode")
    },
    // 绑定手机-手机验证码
    SendBindPhoneCode(){
      return this.$axios.post("/Member/RZJProfile/SendBindPhoneCode",{
        mobliePhone:this.to,
        phoneAreaCode:this.phoneAreaCode
      })
    },
    // 修改绑定手机-原手机验证码
    SendUpdateOldPhoneCode(){
      return this.$axios.post("/Member/RZJProfile/SendUpdateOldPhoneCode")
    },
    // 绑定手机-手机验证码
    SendUpdateNewPhoneCode(){
      return this.$axios.post("/Member/RZJProfile/SendUpdateNewPhoneCode",{
        mobliePhone:this.to,
        phoneAreaCode: this.phoneAreaCode
      })
    },
    // 重置、设置交易密码
    SendTransactionPasswordCode() {
      return this.$axios.post("/Member/RZJProfile/SendTransactionPasswordCode", {
        passWord: Rsa(this.to.pwd),
        affirmPassWord: Rsa(this.to.pwdagain),
        verificationType: this.to.type
      })
    },

    // 申请解除质押
    SendRelievePledgeCode(){
      return this.$axios.post("/Member/RZJPledge/SendRelievePledgeCode", {
        verificationType: this.to
      })
    },
    // 添加或修改注册商管理
    SendOperatorCode(){
      return this.$axios.post("/Member/RZJPledge/SendOperatorCode", {
        codeType: this.to
      })
    }
  },
  destroyed() {
    this.timerClear();
  },
};
</script>
<style lang="less" scoped>
.rela {
  position: relative;
}
</style>

